const state = {
  feedbackList: [],
  currentFeedback: null,
  loading: false
}

const mutations = {
  SET_FEEDBACK_LIST(state, feedbacks) {
    state.feedbackList = feedbacks
  },
  SET_CURRENT_FEEDBACK(state, feedback) {
    state.currentFeedback = feedback
  },
  SET_LOADING(state, status) {
    state.loading = status
  }
}

const actions = {
  // 反馈管理相关操作将在后续实现
}

const getters = {
  feedbackList: state => state.feedbackList,
  currentFeedback: state => state.currentFeedback,
  loading: state => state.loading
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
